import React, { memo } from 'react';
import PropTypes from 'prop-types';

import { Bin } from '@johnlewispartnership/wtr-ingredients/foundations/icons';
import { SmallButton } from '@johnlewispartnership/wtr-ingredients/ingredients/SmallButton';

const DeleteButton = memo(({ action, title }) => {
  const buttonProps = {
    onClick: event => {
      event.preventDefault();
      action();
    },
    title,
    theme: 'primaryWhite',
    startIcon: <Bin data-testid="icon" />,
  };

  return (
    <SmallButton {...buttonProps}>
      <span className="sr-only">{title}</span>
    </SmallButton>
  );
});

DeleteButton.displayName = 'DeleteButton';

DeleteButton.propTypes = {
  action: PropTypes.func.isRequired,
};

export default DeleteButton;
